import type { SVGProps } from "react";
export interface TelescopeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TelescopeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TelescopeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.5 11.876c.425 0 .815.24 1.006.62l4.5 9 .047.106a1.125 1.125 0 0 1-2.003 1l-.057-.099-3.494-6.987-3.493 6.987-.056.1a1.125 1.125 0 0 1-1.957-1.106l4.5-9 .08-.136c.209-.302.554-.485.926-.485Zm-7.79-1.297a1.12 1.12 0 0 1 1.295 1.758c.41.028.789.276.96.68a1.125 1.125 0 0 1-.596 1.475l-1.84.78a1.626 1.626 0 0 1-2.131-.86l-.391-.92c-.35-.827.035-1.78.861-2.13z"
      />
      <path
        fill={color}
        d="M17.524 1.041a2.127 2.127 0 0 1 2.687.914l.104.211 2.641 6.226a2.125 2.125 0 0 1-1.349 2.866l-2.771.825a2.04 2.04 0 0 1-1.332-.057l-10.538 3.43a1.77 1.77 0 0 1-.883.066l-.157-.04c-.679-.204-1.708-.827-2.421-2.507-.714-1.68-.448-2.854-.124-3.485l.083-.139c.2-.308.469-.489.66-.59l9.788-5.199c.179-.44.508-.784.883-.996l2.52-1.421.21-.104Zm-12.19 9.623c-.05.214-.082.674.24 1.432s.676 1.053.865 1.166l9.227-3.004a10 10 0 0 1-1.761-4.146l-8.57 4.552Zm10.68-6.203c-.011.596.066 1.672.607 2.946s1.26 2.076 1.698 2.482l2.51-.747-2.531-5.97z"
      />
    </svg>
  );
}
